/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.174.0-v202608150118-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqFormulasApiClass {
 
   constructor() {}

  /**
   * @summary Clear all formula caches. This method is deprecated.
   * @deprecated Use the DELETE /items/{id}/cache (itemsApi clearCache) instead
  */
  public clearCache(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/clearCache`;



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Compile a Seeq Formula. This method is deprecated.
   * @param {string} [formula] - A formula to be applied.
   * @param {Array<string>} [parameters] - Parameters for the formula. Each parameter should have a format of &#x27;name&#x3D;id&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;id&#x27; is the ID of the item referenced by the variable.
   * @deprecated Use the POST /compile (compileFormulaAndParameters) instead, because compileFormula fails on long input.
  */
  public compileFormula(
    {
      formula,
      parameters
    } : {
      formula?: string,
      parameters?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/compile`;

    const queryParams = {
      ['formula']: formula,      ['parameters']: parameters
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FormulaCompileOutputV1>;
  }

  /**
   * @summary Compile a Seeq Formula. Use this endpoint instead of GET /compile when the input is large.
  */
  public compileFormulaAndParameters(
    body: models.FormulaCompileInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/compile`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaCompileOutputV1>;
  }

  /**
   * @summary Create a function
  */
  public createFunction(
    body: models.FunctionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/functions`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

  /**
   * @summary Create a formula item
  */
  public createItem(
    body: models.FormulaItemInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/items`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaItemOutputV1>;
  }

  /**
   * @summary Permanently delete the specified formula doc
   * @param {string} packageName - The name of the package
   * @param {string} docName - The name of the formula doc
  */
  public deleteFormulaDoc(
    {
      packageName,
      docName
    } : {
      packageName: string,
      docName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }

    if (docName === null || docName === undefined) {
      throw new Error("'docName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)))
      .replace('{docName}', encodeURIComponent(String(docName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Permanently delete a specific user defined formula function
   * @param {string} id - The id of the user defined formula function
  */
  public deleteFunction(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/functions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Permanently delete a specific package
   * @param {string} packageName - The name of the package
  */
  public deletePackage(
    {
      packageName
    } : {
      packageName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/packages/${encodeURIComponent(String(packageName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Run an experimental Seeq Formula. This endpoint is experimental and may change in future releases.
   * @param {string} [formula] - The formula to be applied.
   * @param {Array<string>} [parameters] - Parameters for the formula. Each parameter should have a format of &#x27;name&#x3D;value&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;value&#x27; is the ID of an item or one of the following parameter expressions that can be used to access the properties of other items that are parameters: $signal.property(&#x27;name&#x27;) to access any property on an item, $signal.parentProperty(&#x27;name&#x27;) can be used if an item is in a tree to to access any property on the parent, and $signal.ancestors(&#x27;, &#x27;) to return a list of all the ancestors, separated by the specified separator. In all of the above examples &#x27;signal&#x27; would need to be another parameter that references an item using an ID.
   * @param {Array<string>} [fragments] - Formula fragments for unbound inputs the function. Each parameter should have a format of &#x27;name&#x3D;formula&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;formula&#x27; is a self-contained formula fragment
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public experimental(
    {
      formula,
      parameters,
      fragments
    } : {
      formula?: string,
      parameters?: Array<string>,
      fragments?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/experimental`;

    const queryParams = {
      ['formula']: formula,      ['parameters']: parameters,      ['fragments']: fragments
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FormulaGenericOutputV1>;
  }

  /**
   * @summary Compile a Seeq Formula and show details about the execution plan. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the item to explain.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public formulaExplainer(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/explainer/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FormulaGenericOutputV1>;
  }

  /**
   * @summary A simple summary of Seeq Formula item that shows details about the execution plan. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the item to explain.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public formulaExplainerMarkdown(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/explainer/${encodeURIComponent(String(id))}/markdown`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Get a list of the constants available for use in a calculation
  */
  public getConstantNameList(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/docs/constants`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<Array<string>>;
  }

  /**
   * @summary Get documentation details about a specific function group or index
   * @param {string} packageName - The name of the package
   * @param {string} docName - The name of the document for the desired function or index
  */
  public getFormulaDoc(
    {
      packageName,
      docName
    } : {
      packageName: string,
      docName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }

    if (docName === null || docName === undefined) {
      throw new Error("'docName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)))
      .replace('{docName}', encodeURIComponent(String(docName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FormulaDocOutputV1>;
  }

  /**
   * @summary Get a list of the functions available for use in a calculation
  */
  public getFormulaDocs(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/docs`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FormulaDocSummariesOutputV1>;
  }

  /**
   * @summary Get a collection of Formula Functions
   * @param {string} [type=FormulaFunction] - The type of Formula Functions that should be included. Valid options are FormulaFunction, AggregatingFormulaFunction, Chart, and UserDefinedFormulaFunction
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getFormulaFunctions(
    {
      type,
      offset,
      limit
    } : {
      type?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/functions`;

    const queryParams = {
      ['type']: type,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get a Formula Function
   * @param {string} id - ID of the function
  */
  public getFunction(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/functions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

  /**
   * @summary Get a Formula Item
   * @param {string} id - ID of the item
  */
  public getItem(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/items/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FormulaItemOutputV1>;
  }

  /**
   * @summary Get details of a specific package
   * @param {string} packageName - The name of the package
  */
  public getPackage(
    {
      packageName
    } : {
      packageName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/packages/${encodeURIComponent(String(packageName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.FormulaPackageOutputV1>;
  }

  /**
   * @summary Get a collection of packages
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getPackages(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/packages`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Create or update a package of UDFs with documentation.
  */
  public importPackage(
    body: models.FormulaPackageImportInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/packages/import`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaPackageImportOutputV1>;
  }

  /**
   * @summary Create or update the specified formula doc
   * @param {string} packageName - The name of the package
   * @param {string} docName - The name of the document for the desired function or index
  */
  public putFormulaDoc(
    body: models.FormulaDocInputV1,
    {
      packageName,
      docName
    } : {
      packageName: string,
      docName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }

    if (docName === null || docName === undefined) {
      throw new Error("'docName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)))
      .replace('{docName}', encodeURIComponent(String(docName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaDocOutputV1>;
  }

  /**
   * @summary Create or update a package
   * @param {string} packageName - The name of the package
  */
  public putPackage(
    body: models.FormulaPackageInputV1,
    {
      packageName
    } : {
      packageName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (packageName === null || packageName === undefined) {
      throw new Error("'packageName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/packages/${encodeURIComponent(String(packageName))}`
      .replace('{packageName}', encodeURIComponent(String(packageName)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaPackageOutputV1>;
  }

  /**
   * @summary Run a Seeq Formula
   * @param {string} [start] - A string representing the starting index of the data to be returned as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} [end] - A string representing the ending index of the data to be returned as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} [formula] - The formula to be applied. This or function is required.
   * @param {string} [_function] - The ID of the function item to be computed. This or formula is required.
   * @param {Array<string>} [parameters] - Parameters for the formula. Each parameter should have a format of &#x27;name&#x3D;value&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;value&#x27; is the ID of an item or one of the following parameter expressions that can be used to access the properties of other items that are parameters: $signal.property(&#x27;name&#x27;) to access any property on an item, $signal.parentProperty(&#x27;name&#x27;) can be used if an item is in a tree to to access any property on the parent, and $signal.ancestors(&#x27;, &#x27;) to return a list of all the ancestors, separated by the specified separator. In all of the above examples &#x27;signal&#x27; would need to be another parameter that references an item using an ID.
   * @param {Array<string>} [fragments] - Formula fragments for unbound inputs the function. Each parameter should have a format of &#x27;name&#x3D;formula&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;formula&#x27; is a self-contained formula fragment
   * @param {string} [root] - Used to run a formula across assets, this is the ID of the root asset whose immediate children will be iterated. The formula must produce a table.
   * @param {string} [reduceFormula] - Used when running a formula across assets, this is a formula that can further reduce the results of each asset result. The variable $result must be used to reference the data. Example of sorting the aggregated results: $result.sort(&#x27;temperature&#x27;)&#x27;
   * @param {number} [limit=1000] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [continuationToken] - An opaque token used to query for the next page of results. Only use if returned by a previous call.
   * @param {string} [timeFormat=Legacy]
   * @param {Array<string>} [itemsToScaleAcross] - Used as a list of items across which the formula will be run. The formula must produce a table. The formula must contain a single variable named $series. The Header UOM will be that of the first item.
  */
  public runFormula(
    {
      start,
      end,
      formula,
      _function,
      parameters,
      fragments,
      root,
      reduceFormula,
      limit,
      continuationToken,
      timeFormat,
      itemsToScaleAcross
    } : {
      start?: string,
      end?: string,
      formula?: string,
      _function?: string,
      parameters?: Array<string>,
      fragments?: Array<string>,
      root?: string,
      reduceFormula?: string,
      limit?: number,
      continuationToken?: string,
      timeFormat?: RunFormulaTimeFormatEnum,
      itemsToScaleAcross?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/run`;

    const queryParams = {
      ['start']: start,      ['end']: end,      ['formula']: formula,      ['function']: _function,      ['parameters']: parameters,      ['fragments']: fragments,      ['root']: root,      ['reduceFormula']: reduceFormula,      ['limit']: limit,      ['continuationToken']: continuationToken,      ['timeFormat']: timeFormat,      ['itemsToScaleAcross']: itemsToScaleAcross
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.FormulaRunOutputV1>;
  }

  /**
   * @summary Run a Seeq Formula.
  */
  public runFormula_1(
    body: models.FormulaRunInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/run`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.FormulaRunOutputV1>;
  }

  /**
   * @summary Update a function
   * @param {string} id - ID of the function to update
  */
  public updateFunction(
    body: models.FunctionInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/formulas/functions/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

}

export const RunFormulaTimeFormatEnum = {
    Legacy: 'Legacy',
    ISO8601: 'ISO8601',
    Nanoseconds: 'Nanoseconds'
} as const;

export type RunFormulaTimeFormatEnum = typeof RunFormulaTimeFormatEnum[keyof typeof RunFormulaTimeFormatEnum];

export const sqFormulasApi = new sqFormulasApiClass();

export type sqFormulasApiEndpoints = {
  'clearCache': {
    method: 'post';
    path: '/formulas/clearCache';
    response: models.StatusMessageBase;
  };
  'compileFormula': {
    method: 'get';
    path: '/formulas/compile';
    response: models.FormulaCompileOutputV1;
  };
  'compileFormulaAndParameters': {
    method: 'post';
    path: '/formulas/compile';
    response: models.FormulaCompileOutputV1;
  };
  'createFunction': {
    method: 'post';
    path: '/formulas/functions';
    response: models.CalculatedItemOutputV1;
  };
  'createItem': {
    method: 'post';
    path: '/formulas/items';
    response: models.FormulaItemOutputV1;
  };
  'deleteFormulaDoc': {
    method: 'delete';
    path: '/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}';
    response: models.StatusMessageBase;
  };
  'deleteFunction': {
    method: 'delete';
    path: '/formulas/functions/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'deletePackage': {
    method: 'delete';
    path: '/formulas/packages/${encodeURIComponent(String(packageName))}';
    response: models.StatusMessageBase;
  };
  'experimental': {
    method: 'get';
    path: '/formulas/experimental';
    response: models.FormulaGenericOutputV1;
  };
  'formulaExplainer': {
    method: 'get';
    path: '/formulas/explainer/${encodeURIComponent(String(id))}';
    response: models.FormulaGenericOutputV1;
  };
  'formulaExplainerMarkdown': {
    method: 'get';
    path: '/formulas/explainer/${encodeURIComponent(String(id))}/markdown';
    response: {};
  };
  'getConstantNameList': {
    method: 'get';
    path: '/formulas/docs/constants';
    response: Array<string>;
  };
  'getFormulaDoc': {
    method: 'get';
    path: '/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}';
    response: models.FormulaDocOutputV1;
  };
  'getFormulaDocs': {
    method: 'get';
    path: '/formulas/docs';
    response: models.FormulaDocSummariesOutputV1;
  };
  'getFormulaFunctions': {
    method: 'get';
    path: '/formulas/functions';
    response: models.ItemPreviewListV1;
  };
  'getFunction': {
    method: 'get';
    path: '/formulas/functions/${encodeURIComponent(String(id))}';
    response: models.CalculatedItemOutputV1;
  };
  'getItem': {
    method: 'get';
    path: '/formulas/items/${encodeURIComponent(String(id))}';
    response: models.FormulaItemOutputV1;
  };
  'getPackage': {
    method: 'get';
    path: '/formulas/packages/${encodeURIComponent(String(packageName))}';
    response: models.FormulaPackageOutputV1;
  };
  'getPackages': {
    method: 'get';
    path: '/formulas/packages';
    response: models.ItemPreviewListV1;
  };
  'importPackage': {
    method: 'post';
    path: '/formulas/packages/import';
    response: models.FormulaPackageImportOutputV1;
  };
  'putFormulaDoc': {
    method: 'post';
    path: '/formulas/docs/${encodeURIComponent(String(packageName))}/${encodeURIComponent(String(docName))}';
    response: models.FormulaDocOutputV1;
  };
  'putPackage': {
    method: 'post';
    path: '/formulas/packages/${encodeURIComponent(String(packageName))}';
    response: models.FormulaPackageOutputV1;
  };
  'runFormula': {
    method: 'get';
    path: '/formulas/run';
    response: models.FormulaRunOutputV1;
  };
  'runFormula_1': {
    method: 'post';
    path: '/formulas/run';
    response: models.FormulaRunOutputV1;
  };
  'updateFunction': {
    method: 'post';
    path: '/formulas/functions/${encodeURIComponent(String(id))}';
    response: models.CalculatedItemOutputV1;
  };
};

type ApiClearCacheResponse = models.StatusMessageBase;
type ApiclearCacheMutationParams = Parameters<typeof sqFormulasApi.clearCache> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.clearCache>;

export function useApiClearCacheMutation(
  options?: Omit<UseMutationOptions<ApiClearCacheResponse, AxiosError<SeeqErrorData>,
    ApiclearCacheMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiClearCacheResponse, AxiosError<SeeqErrorData>,
  ApiclearCacheMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: () => sqFormulasApi.clearCache(resolvedOverrides).then((response) => response.data),
    
    ...mutationOptions,
  });
}
type ApiCompileFormulaResponse = models.FormulaCompileOutputV1;
export function CompileFormulaQueryKey(
  params: Parameters<typeof sqFormulasApi.compileFormula>[0],
) {
  return ['sqFormulasApi', 'compileFormula', params] as const;
}

export function useApiCompileFormulaQuery(
  params: Parameters<typeof sqFormulasApi.compileFormula>[0],
  options?: Omit<UseQueryOptions<ApiCompileFormulaResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiCompileFormulaResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: CompileFormulaQueryKey(params),
    queryFn: () =>
      sqFormulasApi.compileFormula(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiCompileFormulaAndParametersResponse = models.FormulaCompileOutputV1;
type ApicompileFormulaAndParametersMutationParams = Parameters<typeof sqFormulasApi.compileFormulaAndParameters> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.compileFormulaAndParameters>;
type ApicompileFormulaAndParametersMutationVariables = models.FormulaCompileInputV1;

export function useApiCompileFormulaAndParametersMutation(
  options?: Omit<UseMutationOptions<ApiCompileFormulaAndParametersResponse, AxiosError<SeeqErrorData>,
    ApicompileFormulaAndParametersMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCompileFormulaAndParametersResponse, AxiosError<SeeqErrorData>,
  ApicompileFormulaAndParametersMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicompileFormulaAndParametersMutationVariables) =>
      sqFormulasApi.compileFormulaAndParameters(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateFunctionResponse = models.CalculatedItemOutputV1;
type ApicreateFunctionMutationParams = Parameters<typeof sqFormulasApi.createFunction> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.createFunction>;
type ApicreateFunctionMutationVariables = models.FunctionInputV1;

export function useApiCreateFunctionMutation(
  options?: Omit<UseMutationOptions<ApiCreateFunctionResponse, AxiosError<SeeqErrorData>,
    ApicreateFunctionMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateFunctionResponse, AxiosError<SeeqErrorData>,
  ApicreateFunctionMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateFunctionMutationVariables) =>
      sqFormulasApi.createFunction(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateItemResponse = models.FormulaItemOutputV1;
type ApicreateItemMutationParams = Parameters<typeof sqFormulasApi.createItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.createItem>;
type ApicreateItemMutationVariables = models.FormulaItemInputV1;

export function useApiCreateItemMutation(
  options?: Omit<UseMutationOptions<ApiCreateItemResponse, AxiosError<SeeqErrorData>,
    ApicreateItemMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateItemResponse, AxiosError<SeeqErrorData>,
  ApicreateItemMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateItemMutationVariables) =>
      sqFormulasApi.createItem(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteFormulaDocResponse = models.StatusMessageBase;
type ApideleteFormulaDocMutationParams = Parameters<typeof sqFormulasApi.deleteFormulaDoc> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.deleteFormulaDoc>;

export function useApiDeleteFormulaDocMutation(
  options?: Omit<UseMutationOptions<ApiDeleteFormulaDocResponse, AxiosError<SeeqErrorData>,
    ApideleteFormulaDocMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteFormulaDocResponse, AxiosError<SeeqErrorData>,
  ApideleteFormulaDocMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteFormulaDocMutationParams) =>
      sqFormulasApi.deleteFormulaDoc(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteFunctionResponse = models.StatusMessageBase;
type ApideleteFunctionMutationParams = Parameters<typeof sqFormulasApi.deleteFunction> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.deleteFunction>;

export function useApiDeleteFunctionMutation(
  options?: Omit<UseMutationOptions<ApiDeleteFunctionResponse, AxiosError<SeeqErrorData>,
    ApideleteFunctionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteFunctionResponse, AxiosError<SeeqErrorData>,
  ApideleteFunctionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteFunctionMutationParams) =>
      sqFormulasApi.deleteFunction(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeletePackageResponse = models.StatusMessageBase;
type ApideletePackageMutationParams = Parameters<typeof sqFormulasApi.deletePackage> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.deletePackage>;

export function useApiDeletePackageMutation(
  options?: Omit<UseMutationOptions<ApiDeletePackageResponse, AxiosError<SeeqErrorData>,
    ApideletePackageMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeletePackageResponse, AxiosError<SeeqErrorData>,
  ApideletePackageMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideletePackageMutationParams) =>
      sqFormulasApi.deletePackage(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiExperimentalResponse = models.FormulaGenericOutputV1;
export function ExperimentalQueryKey(
  params: Parameters<typeof sqFormulasApi.experimental>[0],
) {
  return ['sqFormulasApi', 'experimental', params] as const;
}

export function useApiExperimentalQuery(
  params: Parameters<typeof sqFormulasApi.experimental>[0],
  options?: Omit<UseQueryOptions<ApiExperimentalResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiExperimentalResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ExperimentalQueryKey(params),
    queryFn: () =>
      sqFormulasApi.experimental(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiFormulaExplainerResponse = models.FormulaGenericOutputV1;
export function FormulaExplainerQueryKey(
  params: Parameters<typeof sqFormulasApi.formulaExplainer>[0],
) {
  return ['sqFormulasApi', 'formulaExplainer', params] as const;
}

export function useApiFormulaExplainerQuery(
  params: Parameters<typeof sqFormulasApi.formulaExplainer>[0],
  options?: Omit<UseQueryOptions<ApiFormulaExplainerResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiFormulaExplainerResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: FormulaExplainerQueryKey(params),
    queryFn: () =>
      sqFormulasApi.formulaExplainer(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiFormulaExplainerMarkdownResponse = {};
export function FormulaExplainerMarkdownQueryKey(
  params: Parameters<typeof sqFormulasApi.formulaExplainerMarkdown>[0],
) {
  return ['sqFormulasApi', 'formulaExplainerMarkdown', params] as const;
}

export function useApiFormulaExplainerMarkdownQuery(
  params: Parameters<typeof sqFormulasApi.formulaExplainerMarkdown>[0],
  options?: Omit<UseQueryOptions<ApiFormulaExplainerMarkdownResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiFormulaExplainerMarkdownResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: FormulaExplainerMarkdownQueryKey(params),
    queryFn: () =>
      sqFormulasApi.formulaExplainerMarkdown(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConstantNameListResponse = Array<string>;
export function GetConstantNameListQueryKey(
) {
  return ['sqFormulasApi', 'getConstantNameList'] as const;
}

export function useApiGetConstantNameListQuery(
  options?: Omit<UseQueryOptions<ApiGetConstantNameListResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetConstantNameListResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetConstantNameListQueryKey(),
    queryFn: () =>
      sqFormulasApi.getConstantNameList(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFormulaDocResponse = models.FormulaDocOutputV1;
export function GetFormulaDocQueryKey(
  params: Parameters<typeof sqFormulasApi.getFormulaDoc>[0],
) {
  return ['sqFormulasApi', 'getFormulaDoc', params] as const;
}

export function useApiGetFormulaDocQuery(
  params: Parameters<typeof sqFormulasApi.getFormulaDoc>[0],
  options?: Omit<UseQueryOptions<ApiGetFormulaDocResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFormulaDocResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFormulaDocQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getFormulaDoc(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFormulaDocsResponse = models.FormulaDocSummariesOutputV1;
export function GetFormulaDocsQueryKey(
) {
  return ['sqFormulasApi', 'getFormulaDocs'] as const;
}

export function useApiGetFormulaDocsQuery(
  options?: Omit<UseQueryOptions<ApiGetFormulaDocsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFormulaDocsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFormulaDocsQueryKey(),
    queryFn: () =>
      sqFormulasApi.getFormulaDocs(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFormulaFunctionsResponse = models.ItemPreviewListV1;
export function GetFormulaFunctionsQueryKey(
  params: Parameters<typeof sqFormulasApi.getFormulaFunctions>[0],
) {
  return ['sqFormulasApi', 'getFormulaFunctions', params] as const;
}

export function useApiGetFormulaFunctionsQuery(
  params: Parameters<typeof sqFormulasApi.getFormulaFunctions>[0],
  options?: Omit<UseQueryOptions<ApiGetFormulaFunctionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFormulaFunctionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFormulaFunctionsQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getFormulaFunctions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFunctionResponse = models.CalculatedItemOutputV1;
export function GetFunctionQueryKey(
  params: Parameters<typeof sqFormulasApi.getFunction>[0],
) {
  return ['sqFormulasApi', 'getFunction', params] as const;
}

export function useApiGetFunctionQuery(
  params: Parameters<typeof sqFormulasApi.getFunction>[0],
  options?: Omit<UseQueryOptions<ApiGetFunctionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetFunctionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetFunctionQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getFunction(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemResponse = models.FormulaItemOutputV1;
export function GetItemQueryKey(
  params: Parameters<typeof sqFormulasApi.getItem>[0],
) {
  return ['sqFormulasApi', 'getItem', params] as const;
}

export function useApiGetItemQuery(
  params: Parameters<typeof sqFormulasApi.getItem>[0],
  options?: Omit<UseQueryOptions<ApiGetItemResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetItemResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetItemQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getItem(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPackageResponse = models.FormulaPackageOutputV1;
export function GetPackageQueryKey(
  params: Parameters<typeof sqFormulasApi.getPackage>[0],
) {
  return ['sqFormulasApi', 'getPackage', params] as const;
}

export function useApiGetPackageQuery(
  params: Parameters<typeof sqFormulasApi.getPackage>[0],
  options?: Omit<UseQueryOptions<ApiGetPackageResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetPackageResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetPackageQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getPackage(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPackagesResponse = models.ItemPreviewListV1;
export function GetPackagesQueryKey(
  params: Parameters<typeof sqFormulasApi.getPackages>[0],
) {
  return ['sqFormulasApi', 'getPackages', params] as const;
}

export function useApiGetPackagesQuery(
  params: Parameters<typeof sqFormulasApi.getPackages>[0],
  options?: Omit<UseQueryOptions<ApiGetPackagesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetPackagesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetPackagesQueryKey(params),
    queryFn: () =>
      sqFormulasApi.getPackages(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiImportPackageResponse = models.FormulaPackageImportOutputV1;
type ApiimportPackageMutationParams = Parameters<typeof sqFormulasApi.importPackage> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.importPackage>;
type ApiimportPackageMutationVariables = models.FormulaPackageImportInputV1;

export function useApiImportPackageMutation(
  options?: Omit<UseMutationOptions<ApiImportPackageResponse, AxiosError<SeeqErrorData>,
    ApiimportPackageMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiImportPackageResponse, AxiosError<SeeqErrorData>,
  ApiimportPackageMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiimportPackageMutationVariables) =>
      sqFormulasApi.importPackage(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiPutFormulaDocResponse = models.FormulaDocOutputV1;
type ApiputFormulaDocMutationParams = Parameters<typeof sqFormulasApi.putFormulaDoc> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.putFormulaDoc>;

export function useApiPutFormulaDocMutation(
  options?: Omit<UseMutationOptions<ApiPutFormulaDocResponse, AxiosError<SeeqErrorData>,
    ApiputFormulaDocMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutFormulaDocResponse, AxiosError<SeeqErrorData>,
  ApiputFormulaDocMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiputFormulaDocMutationParams) =>
      sqFormulasApi.putFormulaDoc(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutPackageResponse = models.FormulaPackageOutputV1;
type ApiputPackageMutationParams = Parameters<typeof sqFormulasApi.putPackage> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.putPackage>;

export function useApiPutPackageMutation(
  options?: Omit<UseMutationOptions<ApiPutPackageResponse, AxiosError<SeeqErrorData>,
    ApiputPackageMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutPackageResponse, AxiosError<SeeqErrorData>,
  ApiputPackageMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiputPackageMutationParams) =>
      sqFormulasApi.putPackage(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRunFormula_1Response = models.FormulaRunOutputV1;
export function RunFormula_1QueryKey(
  params: Parameters<typeof sqFormulasApi.runFormula>[0],
) {
  return ['sqFormulasApi', 'runFormula', params] as const;
}

export function useApiRunFormula_1Query(
  params: Parameters<typeof sqFormulasApi.runFormula>[0],
  options?: Omit<UseQueryOptions<ApiRunFormula_1Response, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiRunFormula_1Response, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: RunFormula_1QueryKey(params),
    queryFn: () =>
      sqFormulasApi.runFormula(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRunFormulaResponse = models.FormulaRunOutputV1;
type ApirunFormula_1MutationParams = Parameters<typeof sqFormulasApi.runFormula_1> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.runFormula_1>;
type ApirunFormula_1MutationVariables = models.FormulaRunInputV1;

export function useApiRunFormulaMutation(
  options?: Omit<UseMutationOptions<ApiRunFormulaResponse, AxiosError<SeeqErrorData>,
    ApirunFormula_1MutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRunFormulaResponse, AxiosError<SeeqErrorData>,
  ApirunFormula_1MutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApirunFormula_1MutationVariables) =>
      sqFormulasApi.runFormula_1(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUpdateFunctionResponse = models.CalculatedItemOutputV1;
type ApiupdateFunctionMutationParams = Parameters<typeof sqFormulasApi.updateFunction> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqFormulasApi.updateFunction>;

export function useApiUpdateFunctionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateFunctionResponse, AxiosError<SeeqErrorData>,
    ApiupdateFunctionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateFunctionResponse, AxiosError<SeeqErrorData>,
  ApiupdateFunctionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateFunctionMutationParams) =>
      sqFormulasApi.updateFunction(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
